import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { DealerContextProvider } from "../../contexts/DealerContext.jsx";
import ResultsContainer from "./ResultsContainer.jsx";

const DealerLocator = ({basePath, apiKey, lat, lng, zoom, q, mobileDefaultView}) => {

  return (
    <div className="ft_dealer-locator">
      <Router basename={basePath}>
        <DealerContextProvider apiKey={apiKey} lat={lat} lng={lng} zoom={zoom} q={q} mobileDefaultView={mobileDefaultView}>
          <ResultsContainer />
        </DealerContextProvider>
      </Router>
    </div>
  );

}

export default DealerLocator;
